import { render, staticRenderFns } from "./QuotationSentEdit.vue?vue&type=template&id=51dfc976&scoped=true"
import script from "./QuotationSentEdit.vue?vue&type=script&lang=js"
export * from "./QuotationSentEdit.vue?vue&type=script&lang=js"
import style0 from "./QuotationSentEdit.vue?vue&type=style&index=0&id=51dfc976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dfc976",
  null
  
)

export default component.exports